import SalesReportExport from "../components/SalesReportExport";

const SalesReportExportPage = () => {
  return <SalesReportExport />;
};

export default SalesReportExportPage;
